import { Carousel } from 'antd-mobile';

import { convertStyleData, transformPx2Rem } from '@utils/tools';
import { appMethod as app } from '@utils/app';
import { customEvent } from '@utils/customEvent';

import { RequestStatus } from 'src/common/request-status/RequestStatus';

import './CarouselCustomComponent.less';

export default function CarouselCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  const detailData = props.detailData;    // 详情页数据
  const dynamicData = props.dynamicData;  // 动态数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  const itemStyleObj = {
    borderRadius: transformPx2Rem(customFeature.picBorderRadius, 320),
  }
  const imgHeight = transformPx2Rem(data.style.height, 320);
  /**
   * 组件内容处理
   */   
  let content = data.content;
  const segment = data.customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment];    // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment];   // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 关闭轮播图视频播放
   */
  const carouselVideoClose = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = event.currentTarget.dataset.compindex ;
    pageInstance.setData({
      ['eles[' + compindex + '].videoUrl']: ''
    });
  }
  /**
   * 返回组件
   */ 
  return (
    <div className="custom-component carousel" style={styleObj}>
      <Carousel
        autoplay={customFeature.autoplay}
        autoplayInterval={customFeature.interval*1000}
        vertical={customFeature.vertical}
        infinite
        dotStyle={{background: customFeature.indicatorColor}}
        dotActiveStyle={{background: customFeature.indicatorActiveColor}}
      >
        {content.map((item, itemIndex) => (
          <div
            className="carousel-item"
            key={itemIndex}
            href=""
            style={itemStyleObj}
            onClick={() => customEvent({
              customFeature: {
                ...item.customFeature,
                compindex: props.index
              }
            })}
          >
            <img
              src={item.pic}
              alt={item.name}
              style={{height: imgHeight}}
            />
            {
              item.customFeature.action == 'video-play' &&
              <div className="ico-moon icon-play video-play"></div>
            }
          </div>
        ))}
      </Carousel>
      {/* 加载没有数据 */}
      {
        data.content.length == 0 &&
        <RequestStatus is="requestNone" data={{ data: '你还未添加轮播项~'}}></RequestStatus>
      }
      {
        !!data.videoUrl &&
        <div className="carousel-video-play">
          <div className="inner" style={{
            marginTop: transformPx2Rem(data.carouselVideoTop, 320)
          }}>
            <div className="icon-moon icon-closes close" onClick={carouselVideoClose} data-compindex={props.index}></div>
            <video src={data.videoUrl} controls preload="meta"></video>
          </div>
        </div>
      }
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/carousel-custom-component/CarouselCustomComponent.jsx